import { useContext, useEffect } from 'react'
import pclnExperimentation from '@pcln/experimentation'
import ExperimentContext from '@/context/ExperimentContext'
import useGA4AnalyticsForSETI from './useGA4Analytics'

export default function useSeti(
  experimentCode: string,
  shouldFireImpression = true
) {
  const { [experimentCode]: setiTest = 'DEFAULT' } =
    useContext(ExperimentContext)

  const { logGA4Event } = useGA4AnalyticsForSETI(experimentCode)
  useEffect(() => {
    if (experimentCode && shouldFireImpression) {
      pclnExperimentation.fireImpression(experimentCode)
      logGA4Event()
    }
  }, [experimentCode, logGA4Event, shouldFireImpression])

  return setiTest
}
